import meta from '../assets/companies/meta.png';
import coderabbit from '../assets/companies/coderabbit.png';
import shopify from '../assets/companies/shopify.png';
import semper8 from '../assets/companies/semper8.png';
import hamming from '../assets/companies/hamming.png';
import bmo from '../assets/companies/bmo.png';
import cibc from '../assets/companies/cibc.png';
import hatchcoding from '../assets/companies/hatchcoding.png';
import uwblueprint from '../assets/companies/uwblueprint.png';
import uwaterloo from '../assets/companies/uwaterloo.png';

const experiences = [
  {
    year: '09/2026 - 12/2026',
    works: [
      {
        name: 'Undergraduate Research Assistant',
        company: 'University of Waterloo',
        desc: '',
        logo: uwaterloo,
      },
    ],
  },
  {
    year: '06/2026 - 08/2026',
    works: [
      {
        name: 'Production Engineer Intern',
        company: 'Meta',
        desc: '',
        logo: meta,
      },
    ],
  },
  {
    year: '01/2026 - 04/2026',
    works: [
      {
        name: 'Applied AI Engineer Intern',
        company: 'CodeRabbit',
        desc: '',
        logo: coderabbit,
      },
    ],
  },
  {
    year: '09/2025 - 12/2025',
    works: [
      {
        name: 'Tech Lead',
        company: 'UW Blueprint',
        desc: '',
        logo: uwblueprint,
      },
    ],
  },
  {
    year: '01/2025 - 04/2025',
    works: [
      {
        name: 'Software Engineer Intern',
        company: 'Shopify',
        desc: '',
        logo: shopify,
      },
    ],
  },
  {
    year: '05/2024 - 08/2024',
    works: [
      {
        name: 'Software Developer Intern',
        company: 'Semper8',
        desc: '',
        logo: semper8,
      },
    ],
  },
  {
    year: '03/2024 - 06/2024',
    works: [
      {
        name: 'AI/ML Researcher',
        company: 'Hamming.AI x WAT.AI',
        desc: '',
        logo: hamming,
      },
    ],
  },
  {
    year: '09/2023 - 12/2023',
    works: [
      {
        name: 'Software Developer Intern',
        company: 'BMO',
        desc: '',
        logo: bmo,
      },
    ],
  },
  {
    year: '01/2023 - 04/2023',
    works: [
      {
        name: 'SDET Intern',
        company: 'CIBC',
        desc: '',
        logo: cibc,
      },
    ],
  },
  {
    year: '06/2021 - 06/2022',
    works: [
      {
        name: 'Coding Instructor',
        company: 'Hatch Coding',
        desc: '',
        logo: hatchcoding,
      },
    ],
  },
];

export default experiences;
